/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mantine/core';
import { AlertCircle } from 'tabler-icons-react';
import AppStack from '../../../../../common/AppStack';
import AppCard from '../../../../../common/AppCard';
import AppFlexbox from '../../../../../common/AppFlexbox';
import AppText from '../../../../../common/AppText';
import WsFinalSaleWarning from '../finalSaleWarning/WsFinalSaleWarning';

const WsBuyButtonsBlock = ({
  isUnavailable,
  selectedVariants,
  selectedVariantsInfo,
  isBundleProduct,
  isExternalProduct,
  submitting,
  config,
  optionErrors,
  mediaQueries,
  editModeEnabled
}) => {
  const outOfStock = selectedVariantsInfo.some((v) => v.outOfStock);

  return (
    <AppStack>
      {optionErrors && optionErrors.length > 0 && (
        <AppCard
          radius={0}
          shadow="xs"
          style={{ padding: 0, marginTop: 10 }}
          withBorder
        >
          <AppFlexbox
            style={{
              padding: 8,
              gap: 8,
              backgroundColor: '#c40000',
              color: '#fff'
            }}
          >
            <AppStack>
              <AlertCircle size={18} />
            </AppStack>
            <AppText style={{ fontSize: 14 }}>{optionErrors[0]}</AppText>
          </AppFlexbox>
        </AppCard>
      )}

      <Button
        color="dark"
        disabled={isUnavailable || outOfStock}
        loading={submitting}
        radius={0}
        size="lg"
        style={{ width: '100%', maxWidth: 400, maxHeight: 46, marginTop: 4 }}
        type="submit"
        variant="filled"
      >
        {outOfStock
          ? 'Out of stock'
          : isUnavailable
          ? 'Unavailable'
          : 'Add to Cart'}
      </Button>

      {isExternalProduct && (
        <WsFinalSaleWarning
          editModeEnabled={editModeEnabled}
          mediaQueries={mediaQueries}
        />
      )}
    </AppStack>
  );
};

WsBuyButtonsBlock.propTypes = {
  config: PropTypes.object,
  ecomStoreProduct: PropTypes.object,
  editModeEnabled: PropTypes.bool,
  isBundleProduct: PropTypes.bool,
  isExternalProduct: PropTypes.bool,
  isUnavailable: PropTypes.bool,
  mediaQueries: PropTypes.object,
  optionErrors: PropTypes.array,
  selectedVariants: PropTypes.array,
  selectedVariantsInfo: PropTypes.array,
  submitting: PropTypes.bool
};

export default WsBuyButtonsBlock;
